// extracted by mini-css-extract-plugin
export var automute_ico = "vplay-module--automute_ico--48b38";
export var d_automute = "vplay-module--d_automute--a1a43";
export var vplay = "vplay-module--vplay--e818c";
export var vplay_automute = "vplay-module--vplay_automute--eb6fe";
export var vplay_bigplay = "vplay-module--vplay_bigplay--1b29e";
export var vplay_btn = "vplay-module--vplay_btn--62a39";
export var vplay_cap = "vplay-module--vplay_cap--72817";
export var vplay_prog = "vplay-module--vplay_prog--e50d0";
export var vplay_track = "vplay-module--vplay_track--71a8e";
export var vplay_trackwr = "vplay-module--vplay_trackwr--ba115";